export default __webpack_public_path__ + "static/media/HomeBGFull.b610e2ce.jpg";